<div [formGroup]="formGroup">
  <p
    *ngIf="isShowLabelOutside"
    class="tui-space_bottom-2"
  >
    <b>
      {{ label }}
      <span *ngIf="validators.required">*</span>
    </b>
  </p>
  <tui-input-date
    tuiUnfinishedValidator="Finish filling the field"
    [formControlName]="formControlName"
    [max]="max"
    [min]="min"
    [nativeId]="id"
    [pseudoFocus]="focus ?? null"
    [pseudoInvalid]="invalid === undefined ? null : invalid"
    [readOnly]="properties?.readOnly ?? false"
    [tuiHintContent]="hintContent"
    [tuiTextfieldCleaner]="true"
    [tuiTextfieldLabelOutside]="isShowLabelOutside"
    [tuiTextfieldIconLeft]="icon"
    [tuiTextfieldPostfix]="postfix"
    [tuiTextfieldPrefix]="prefix"
    [tuiTextfieldSize]="size"
    (focusedChange)="handleFocusedChange($event)"
  >
    <div *ngIf="!isShowLabelOutside">
      {{ label }}
      <span
        class="tui-required"
        *ngIf="validators.required"
      ></span>
    </div>
    <div *ngIf="isShowLabelOutside">
      {{ placeholder }}
    </div>
    <input
      tuiTextfield
      [attr.placeholder]="placeholder ?? ''"
      [attr.required]="validators.required"
    />
  </tui-input-date>
</div>
